<script setup>
import ToggleSwitch from 'dashboard/components-next/switch/Switch.vue';

defineProps({
  header: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
  hideToggle: {
    type: Boolean,
    default: false,
  },
});

const modelValue = defineModel({ type: Boolean, default: false });
</script>

<template>
  <div
    class="chatmigo-elevated-card flex flex-col items-start overflow-hidden rounded-xl outline outline-1 -outline-offset-1 outline-n-container [interpolate-size:allow-keywords]"
  >
    <div class="flex w-full flex-col items-start gap-1.5 px-4 py-3.5">
      <div class="flex w-full items-start justify-between gap-3">
        <span class="text-sm font-semibold tracking-tight text-n-slate-12">
          {{ header }}
        </span>
        <template v-if="hideToggle">
          <slot name="hiddenToggle">
            <div class="size-2" />
          </slot>
        </template>
        <ToggleSwitch v-else v-model="modelValue" />
      </div>
      <span
        v-if="description"
        class="text-sm leading-5 text-n-slate-11"
      >
        {{ description }}
      </span>
      <slot />
    </div>
    <div
      v-if="$slots.editor"
      class="w-full border-t border-n-weak bg-n-alpha-1 dark:bg-n-solid-1/60"
      :class="{ 'p-0': compact, 'px-4 pb-4 pt-2': !compact }"
    >
      <slot name="editor" />
    </div>
  </div>
</template>
